import axios from "axios";
import { BASE_URL_API } from "./Constants";

const mobileApiInstance = axios.create({
  baseURL: `${BASE_URL_API}/mobileapis`,
  headers: {
    "Content-Type": "application/json",
  },
});
// api call to get communities list
async function getCommunitiesList(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-communities-list?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get community detail
async function getCommunitieDetail(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-community-detail?community_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get community workouts
async function getCommunitieProgramsList(prams) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-community-programs-list?${prams}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get User owner communities list
async function getUserOwnerCommunitiesList(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-user_owner_communities-list?user_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to create community
async function createCommunity(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: "/create-community",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to edit community
async function editCommunity(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: "/edit-community",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to delete community
async function deleteCommunity(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "post",
      url: "/delete-community",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

//get trainer clients
async function getTrainerDashboardClients(type) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");

    var config = {
      method: "get",
      url: `get-trainer-dashboard-stats-clients?type=${type}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };
    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// api call to get promotions list
async function getFeaturedPromotedContent() {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("metatoken");
    var config = {
      method: "get",
      url: `/get-featured-promoted-content`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await mobileApiInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

const CommunityServices = {
  getCommunitiesList,
  getCommunitieDetail,
  getCommunitieProgramsList,
  getUserOwnerCommunitiesList,
  createCommunity,
  editCommunity,
  deleteCommunity,
  getTrainerDashboardClients,
  getFeaturedPromotedContent,
};

export default CommunityServices;
